import { Component, OnInit } from '@angular/core';
import {  FormBuilder, FormGroup} from '@angular/forms';
import { AccessUserInfo, labFrequencyAlertRule, UserDetail } from 'src/app/models';
import { LoaderService } from 'src/app/services/loader.service';
import { LabManagerService } from 'src/app/services/water-lab/lab-manager.service';
import { MessageService } from 'src/app/services/toaster/message.service'
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { UserService } from 'src/app/services/user.service';
@Component({
  selector: 'bart-lab-frequency-alert',
  templateUrl: './lab-frequency-alert.component.html',
  styleUrls: ['./lab-frequency-alert.component.scss']
})
export class LabFrequencyAlertComponent implements OnInit {
  public userInfo: UserDetail;
  labfrequencyselectButton: any[];
  selectedIndex: number = 0;
  tableHeader: any;
  labFrequencyData: labFrequencyAlertRule[] = []
  labFrequencyStateExceptionData: any[] = []
  labFrequencyForm: FormGroup;
  justifyOptions: any[];
  constructor(private formBuilder: FormBuilder,
    private _loaderService: LoaderService,
    private _labManagerService: LabManagerService,
    private _messageService: MessageService,
    private _userService: UserService,

  ) { }
  ngOnInit() {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.labFrequencyForm = this.formBuilder.group(
      {
        yearly: [null,],
        semiYearly: [null,],
        quarterly: [null,],
        monthly: [null,],
        weekly: [null,],
      },
    );
    this.getLabFrequencyAlerts();
    this.tableHeader = [   
      { field: 'StateName', header: 'State', display: 'table-cell', },
    ];
    this.labfrequencyselectButton = [{ label: 'Assignments', value: 0 }, { label: 'State Exceptions', value: 1 }];
  }
  selectButtonChangeEvent(value: any) {
    this.selectedIndex = value;
    if (value == 0) {
      this.getLabFrequencyAlerts();
    }
    else {
      this.getStateExceptions();
    }
  }
  saveLabrequestAlert() {
    this._loaderService.show();
    // if (this.labFrequencyForm.valid) {
      let labFrequencyAlert = {
        "UPDATELABFREQUENCYALERTRULE": {
          UserName: this.userInfo.userName,
          yearly: this.labFrequencyForm.get("yearly").value,
          semiYearly: this.labFrequencyForm.get("semiYearly").value,
          quarterly: this.labFrequencyForm.get("quarterly").value,
          monthly: this.labFrequencyForm.get("monthly").value,
          weekly: this.labFrequencyForm.get("weekly").value,
        }
      }
      this._labManagerService.updateLabFrequencyAlertRule(JSON.stringify(labFrequencyAlert)).subscribe(data => {
        this._loaderService.hide();
        this._messageService.showAlertMessage("Success:The frequencies have been updated.")
      },
        err => {
          this._loaderService.hide()
        });
    // }
     //#region User Action Audit
     this._userService.logUserAction({
      userName:this.userInfo.userName,
      userAction:UserAction.BUTTON_CLICKED,
      screenName:ScreenName.LAB_MANAGER,
      screenPath:location.pathname,
      key:'userName:yearly:semiYearly:quarterly:monthly:weekly',
      value:this.userInfo.userName
      +':'+this.labFrequencyForm.get("yearly").value      
      +':'+this.labFrequencyForm.get("semiYearly").value
      +':'+this.labFrequencyForm.get("quarterly").value
      +':'+this.labFrequencyForm.get("monthly").value
      +':'+this.labFrequencyForm.get("weekly").value,
      eventDescription:UserActionDescription.LAB_FREQUENCY_ALERTS_ASSIGNMENTS_APPLY_CLICKED
    }); 
    //#endregion

  }
  getLabFrequencyAlerts() {
    this._loaderService.show();
    this._labManagerService.getLabFrequencyAlertsRule().subscribe(response => {
      if(response){
      this.labFrequencyData = response.getLabFrequencyAlertsRule;
      this.labFrequencyForm.patchValue({
        yearly: this.labFrequencyData[0].Yearly,
        semiYearly: this.labFrequencyData[0].SemiYearly,
        quarterly: this.labFrequencyData[0].Quarterly,
        monthly: this.labFrequencyData[0].Monthly,
        weekly: this.labFrequencyData[0].Weekly
      })
      this._loaderService.hide()
    }
    else{
      this._loaderService.hide()
    }
    },
      (error) => {
        this._loaderService.hide()
      });

      //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.LAB_MANAGER,
      screenPath: location.pathname,
      key: "",
      value: '',
      eventDescription:UserActionDescription.LAB_FREQUENCY_ALERTS_ASSIGNMENTS_LOADED
    });
    //#endregion
  }
  getStateExceptions() {
    this._loaderService.show();
    this._labManagerService.getStateException().subscribe(response => {
      if(response){
        this.labFrequencyStateExceptionData = response.getStateException;
        this._loaderService.hide()
      }
      else{
        this._loaderService.hide()
      }
    },
      (error) => {
        this._loaderService.hide()
      });

        //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.LAB_MANAGER,
      screenPath: location.pathname,
      key: "",
      value: '',
      eventDescription:UserActionDescription.LAB_FREQUENCY_ALERTS_STATE_EXCEPTIONS_GRID_LOADED
    });
    //#endregion

  }
  handleChange(event, rowData: any) {
    this._loaderService.show();
    let isChecked = event.checked;
    let updateStateException = {
      "UPDATESTATEEXCEPTION":
      {
        UserName: this.userInfo.userName,
        ActiveFlag: isChecked,
        StateCode: rowData.StateCode
      }
    }
    this._labManagerService.UpdateStateException(JSON.stringify(updateStateException)).subscribe(data => {
      this._loaderService.hide();
    },
      err => {
        this._loaderService.hide()
      });


       //#region User Action Audit
    this._userService.logUserAction({
      userName:this.userInfo.userName,
      userAction:UserAction.BUTTON_CLICKED,
      screenName:ScreenName.LAB_MANAGER,
      screenPath:location.pathname,
      key:'StateCode',
      value:rowData.StateCode,
      eventDescription:UserActionDescription.LAB_FREQUENCY_ALERTS_STATE_EXCEPTIONS_ACTIVE_CLICKED
    }); 
    //#endregion


  }
  onInput(event: Event,controlName) {
    const target = event.target as HTMLInputElement;
    const value = Number(target.value);
    if(controlName=='yearly' || controlName=='semiYearly'){
      if(!isNaN(value)){
        if (value > 365 || isNaN(value)) {
          target.value = target.value.toString().substring(0,2);
          this.labFrequencyForm.get(controlName).setValue(target.value.match(/\d+/g))
         }
      }
      else{
        this.labFrequencyForm.get(controlName).setValue(target.value.match(/\d+/g))
      }
    }
    else{
      if(!isNaN(value)){
        if (value > 99 || isNaN(value)) {
          target.value = target.value.toString().substring(0,2);
          this.labFrequencyForm.get(controlName).setValue(target.value.match(/\d+/g))
         }
      }
      else{
        this.labFrequencyForm.get(controlName).setValue(target.value.match(/\d+/g))
      }
    }
  }
  sortColumn(event)
  {
//#region User Action Audit
   this._userService.logUserAction({
     userName: this.userInfo.userName,
     userAction: UserAction.SORT,
     screenName: ScreenName.LAB_MANAGER,
     screenPath: location.pathname,
     key: event.field,
     value: event.order === 1 ? 'ASC' : 'DESC',
     eventDescription:UserActionDescription.LAB_FREQUENCY_ALERTS_STATE_EXCEPTIONS_COLUMN_SORT
   });
   //#endregion

 }
 paginate(event) 
  {
    
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.PAGE_CHANGED,
      screenName: ScreenName.LAB_MANAGER,
      screenPath: location.pathname,
      key: 'Selected_Page_No',
      value: (event.first / event.rows) + 1,
      eventDescription:UserActionDescription.LAB_FREQUENCY_ALERTS_STATE_EXCEPTIONS_PAGE_NO_CLICKED
    });
    //#endregion
  }


}
